<template>
  <div class="settle">
    <nav-bar
      fixed
      z-index="99"
      title=""
      left-text="返回"
      right-text="个人中心"
      left-arrow
      @click-left="$router.go(-1)"
      @click-right="$router.push('/user')"
    />
    <div style="height: 46px"></div>
    <div class="title">{{ type === "0" ? "首次预约" : type === "3" ? "单次预约" : "续约" }}</div>
    <form class="settle-form acea-row row-column" @submit.prevent="createOrder">
      <div class="order-detail">
        <div class="title-name" v-if="type !== '3'">
          {{ type === "0" ? "首次预约" : "续约" }}套餐
        </div>
        <!-- 首次预约套餐选择 -->
        <div class="package-options" v-if="type === '0'">
          <div class="package-option package-selected">
            <div class="option-info">
              <div class="option-name">首次预约</div>
            </div>  
            <div class="option-price">
                <template v-if="pageType == 'coach'">
                  ￥{{ productDetail.storeInfo.welfarePrice }}
                </template>
                <template v-else>
                  ￥{{ $store.state.app.isFree ? "0" : first_price }}
                </template>
              </div>
            <span class="check-icon">✓</span>
          </div>
        </div>
        <!-- 新版续约套餐选择布局 -->
        <div class="package-options" v-else>
          <div 
            v-for="(item, index) in validPackages" 
            :key="index" 
            class="package-option"
            :class="{'package-selected': priceIndex === item.originalIndex}"
            @click="priceIndex = item.originalIndex"

          >
            <div class="option-info">
              <div class="option-name">{{ item.skuName }}
              </div>
            </div>
            <div class="option-price">￥{{ item.price }}</div>
            <span class="check-icon" v-if="priceIndex === item.originalIndex">✓</span>
          </div>
        </div>
        <div style="padding-bottom: 0.4rem; margin: 0 -10px" v-if="type !== '0'">
          <div @click="couponTap">
            <cell title="优惠券" is-link>
              {{ usableCoupon.couponTitle || "请选择" }}
            </cell>
          </div>
        </div>
        <div v-if="type == '0'">
          <div style="line-height: 1.8; color: #ff7733; margin-top: 0.4rem">
            <div v-html="productDetail.firstDesc"></div>
          </div>
        </div>
        <div class="btn"
          :class="{ disabled: loading || onBtn }"
          @click="handleOrderSubmission()"
        >立即预约</div>
      </div>
    </form>
    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderGroupInfo.priceGroup.totalPrice"
      :cartid="cartid"
      :checked="usableCoupon.id"
      :type="type"
      @checked="changeCoupon"
    ></CouponListWindow>
  </div>
</template>

<script>
import { createOrder, postOrderConfirm } from "@api/order";
import { getProductDetail, postCartAdd } from "@api/store";
import { mapGetters } from "vuex";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
import { NavBar, Cell, Dialog } from "vant";
import { getDict } from "@api/admin";
import { getQRcode } from "@api/public";
import CouponListWindow from "@components/CouponListWindow";
import { getUserInfo } from "@api/user";

const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
export default {
  name: NAME,
  components: { NavBar, CouponListWindow, Cell },
  props: {},
  data: function () {
    return {
      id: "",
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      enableIntegral: true,
      enableIntegralNum: 0,
      isWeixin: _isWeixin,
      pinkId: 0,
      active: _isWeixin ? "weixin" : "yue",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {},
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        payPrice: "计算中",
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      cartid: "",
      type: "1",
      packagePrice: [],
      priceIndex: 0,
      kefu: "",
      first_price: "",
      onBtn: false,
      productDetail: {},
      pageType: "",
      loading: true,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "storeItems"]),
    // 过滤有效的套餐选项
    validPackages() {
      const mapped = this.packagePrice.map((item, index) => ({ ...item, originalIndex: index }));
      if (this.type === '3') {
        // 单次：只展示 index=0 的单次SKU
        return mapped.filter(item => item.originalIndex === 0);
      }
      // 续约：展示 index!=0 且已开放的套餐（原逻辑不变）
      return mapped.filter(item => item.originalIndex !== 0 && item.isOpen === 1);
    }
  },
  watch: {
    priceIndex() {
      this.getCartInfo();
    },
    packagePrice: {
      handler(newValue) {
        if (!newValue || newValue.length === 0) return;
        if (this.type === '3') {
          // 单次：默认选中 index=0 的套餐
          this.priceIndex = 0;
        } else {
          // 续约：找第一个可用的非零索引套餐
          const firstValidIndex = newValue.findIndex((item, index) => index != 0 && item.isOpen == 1);
          if (firstValidIndex > -1) {
            this.priceIndex = firstValidIndex;
          }
        }
      },
      immediate: true
    }
  },
  mounted: async function () {
    this.loading = true;
    await getDict({ name: "first_price" }).then((res) => {
      this.first_price = res.data[0].value;
    });
    let that = this;
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;

    if (that.$route.params.id !== undefined) that.id = that.$route.params.id;
    this.type = that.$route.query.type;
    await that.getDetail();
    await this.getQRcodeImg();
    this.pageType = that.$route.query.pageType;
    this.loading = false;
  },
  methods: {
    handleOrderSubmission() {
      if (this.loading) {
        this.$dialog.toast({ mes: "页面未加载完毕，请稍后再试" });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
        return;
      }
      if (!this.loading && !this.onBtn) {
        this.createOrder();
      }
    },
    getQRcodeImg: function () {
      getQRcode().then((res) => {
        this.kefu = res.data.value;
      });
    },
    getDetail: function () {
      getProductDetail(this.id).then((res) => {
        if (res.status === 200) {
          let arr = [];
          for (let key in res.data.productValue) {
            arr.push({
              num: key,
              id: res.data.productValue[key].id,
              price: res.data.productValue[key].price,
              unique: res.data.productValue[key].unique,
              skuName: res.data.productValue[key].skuName,
              isOpen: res.data.productValue[key].isOpen,
            });
          }

          console.log("arr:", arr);
          this.productDetail = res.data;
          this.packagePrice = arr;
          // 找到第一个可用的套餐索引
          const firstValidIndex = arr.findIndex((item, index) => index != 0 && item.isOpen == 1);
          if (firstValidIndex > -1) {
            this.$log.info("找到第一个有效套餐索引:", firstValidIndex);
            this.priceIndex = firstValidIndex;
          }
        }
      });
    },
    couponTap: function () {
      console.log(9999);
      this.showCoupon = true;
    },
    changeCoupon: function (coupon) {
      console.log("coupon:", coupon);
      if (!coupon) {
        this.usableCoupon = { couponTitle: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
    },
    async getCartInfo() {
      if (!this.packagePrice || !this.packagePrice[this.priceIndex]) {
        return;
      }
      console.log("getCartInfogetCartInfogetCartInfogetCartInfo");
      let q = {
        productId: this.id,
        cartNum: 1,
        new: 1,
        uniqueId:
          this.type == 1 ? this.packagePrice[this.priceIndex].unique : "",
      };
      const cartData = await postCartAdd(q);
      const cartIds = cartData.data.cartId;
      this.cartid = cartData.data.cartId;
      // 单次 0 (value = "订单类型 0 普通订单 1首约订单 2公益订单")
      let type = this.type == 0 ? 1 : 0;

      postOrderConfirm(cartIds, type)
        .then((res) => {
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.enableIntegral = res.data.enableIntegral;
          this.enableIntegralNum = res.data.enableIntegralNum;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.systemStore || {};
          this.store_self_mention = res.data.storeSelfMention;
        })
        .catch(() => {
          this.$dialog.error("加载订单数据失败");
        });
    },
    async createOrder() {
      if (this.loading) {
        this.$dialog.toast({ mes: "数据加载中，请稍后..." });
        return;
      }
      const userRes = await getUserInfo();
      const userInfo = userRes.data;
      if (!userInfo.phone) {
        this.$dialog.confirm({
          mes: "您的用户基础信息尚未填写，为了便于教练联系到您，请补充完整。",
          opts: [
            {
              txt: "返回",
              color: false,
              callback: () => {
                this.$router.go(-1);
              },
            },
            {
              txt: "去完善",
              color: true,
              callback: () => {
                this.$router.push("/settle_in?stepActive=1");
              },
            },
          ],
        });
        return;
      }
      if (this.onBtn) return;
      this.onBtn = true;
      let shipping_type = this.shipping_type;
      this.$dialog.loading.open("生成订单中");
      createOrder(this.orderGroupInfo.orderKey, {
        realName: this.contacts,
        phone: this.contactsTel,
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        payType: "weixin",
        pinkId: this.pinkId,
        seckillId: this.orderGroupInfo.seckill_id,
        combinationId: this.orderGroupInfo.combination_id,
        bargainId: this.orderGroupInfo.bargain_id,
        from: this.from,
        mark: this.mark || "",
        shippingType: parseInt(shipping_type) + 1,
        storeId: this.storeItems.id || this.system_store.id,
        firstOrder: this.pageType == "coach" ? 0 : this.type == "0" ? 1 : 0,
        channelid: sessionStorage.getItem("channelid"),
        welfareOrder: this.pageType == "coach" ? 1 : 0,
        source: this.$route.query.source || 2,
        reviewOrderId: this.$route.query.reviewOrderId,
      })
        .then((res) => {
          this.onBtn = false;
          this.$dialog.loading.close();
          const data = res.data;
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              this.$dialog.toast({ mes: res.msg });
              this.$router.replace({
                path: "/order/status/" + data.result.orderId,
                query: { type: this.type },
              });
              break;
            case "SUCCESS":
              this.$dialog.success(res.msg);
              this.$router.replace({
                path: "/order/status/" + data.result.orderId,
                query: {
                  price:
                    this.type == 1
                      ? this.packagePrice[this.priceIndex].price
                      : this.first_price,
                  type: this.type,
                  packageName: this.packagePrice[this.priceIndex].skuName || "未知套餐",
                  packageSku: this.packagePrice[this.priceIndex].num || "",
                  packageOnePrice: this.packagePrice[this.priceIndex].price / this.packagePrice[this.priceIndex].num
                },
              });
              break;
            case "WECHAT_H5_PAY":
              this.$router.replace({
                path: "/order/status/" + data.result.orderId,
                query: {
                  price:
                    this.type == 1
                      ? this.packagePrice[this.priceIndex].price
                      : this.first_price,
                  type: this.type,
                  packageName: this.packagePrice[this.priceIndex].skuName || "未知套餐",
                  packageSku: this.packagePrice[this.priceIndex].num || "",
                  packageOnePrice: this.packagePrice[this.priceIndex].price / this.packagePrice[this.priceIndex].num
                },
              });
              setTimeout(() => {
                location.href = data.result.jsConfig.mweb_url;
              }, 100);
              break;
            case "WECHAT_PAY":
              pay(data.result.jsConfig).finally(() => {
                this.$router.replace({
                  path: "/order/status/" + data.result.orderId,
                  query: {
                    price:
                      this.type == 1
                        ? this.packagePrice[this.priceIndex].price
                        : this.first_price,
                    type: this.type,
                    packageName: this.packagePrice[this.priceIndex].skuName || "未知套餐",
                    packageSku: this.packagePrice[this.priceIndex].num || "",
                    packageOnePrice: this.packagePrice[this.priceIndex].price / this.packagePrice[this.priceIndex].num
                  },
                });
              });
          }
        })
        .catch((err) => {
          console.log(err);
          this.onBtn = false;
          this.$dialog.loading.close();
          this.$dialog.error(err.msg || "创建订单失败");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.order-detail {
  padding: 0.3rem 0.23rem;
  .title-name {
    font-size: 0.28rem;
    font-weight: 700;
  }
  .pay-bg {
    margin-top: 0.4rem;
    width: 100%;
    height: 3.2rem;
    background: url("~@/assets/img/pay_bg.png") no-repeat;
    background-size: 100%;
    background-position: center;
    text-align: center;
    img {
      width: 3rem;
      margin: 0.15rem 0.15rem 0 0;
    }
  }
  .price-box {
    padding: 0.4rem;
    .price-item {
      width: 2rem;
      padding: 0.19rem;
      border: 1px solid #193e52;
      position: relative;
      text-align: center;
      font-size: 0.23rem;
      color: #999999;
      margin: 0 0.19rem;
    }
    span {
      color: #000;
      font-size: 0.26rem;
      font-weight: 700;
    }
    svg {
      position: absolute;
      right: 0;
      bottom: -0.1rem;
      width: 0.4rem;
      height: 0.4rem;
    }
  }
}

/* 新增套餐选择样式 */
.package-options {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.4rem 0;
  
  .package-option {
    position: relative;
    border-radius: 0.16rem;
    padding: 0.40rem;
    background-color: rgba(255, 165, 0, 0.2); /* 浅橙色 */
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &.package-selected {
      background-color: #FF8C00; /* 橙色 */
      color: #fff;
      
      .option-price, .option-times {
        color: #fff;
      }
    }
    
    .option-info {
      display: flex;
      flex-direction: column;
      gap: 0.1rem;
    }
    
    .option-name {
      font-size: 0.28rem;
      font-weight: bold;
    }
    
    .option-price {
      font-size: 0.26rem;
      color: #ee0a24;
      font-weight: bold;
    }
    
    .option-times {
      font-size: 0.26rem;
      color: #333;
    }
    
    .check-icon {
      position: absolute;
      right: 0.16rem;
      bottom: 0.1rem;
      font-size: 0.32rem;
      color: #fff;
      font-weight: bold;
    }
  }
}

.btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
